var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[(_vm.showFormEks)?_c('live-eks'):_vm._e(),(_vm.showFormLeg)?_c('live-leg'):_vm._e(),(_vm.showFormDpd)?_c('live-dpd'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }